export default [
  {
    "x": 109.891,
    "y": 155.9351,
    "angle": 2.2272828504913917,
    "lengthA": 16.14231754774144,
    "lengthB": 6.410811287151105
  },
  {
    "x": 97.041,
    "y": 143.0851,
    "angle": 0,
    "lengthA": 7.097000000000008,
    "lengthB": 8.067466600000003
  },
  {
    "x": 69.811,
    "y": 143.0851,
    "angle": 0.6146355626088653,
    "lengthA": 3.81482306262223,
    "lengthB": 10.395696112188203
  },
  {
    "x": 59.857,
    "y": 116.8391,
    "angle": -0.0029122883307168774,
    "lengthA": 9.954042212193052,
    "lengthB": 9.954042212193045
  },
  {
    "x": 39.111,
    "y": 116.8951,
    "angle": -0.002376623713155245,
    "lengthA": 6.683016273966107,
    "lengthB": 11.868033515373343
  },
  {
    "x": 29.221,
    "y": 168.7221,
    "angle": -0.40903009427826087,
    "lengthA": 3.5215210161082533,
    "lengthB": 4.880973184110932
  },
  {
    "x": 2,
    "y": 114.6171,
    "angle": -0.5355837320968009,
    "lengthA": 4.85313489697459,
    "lengthB": 9.258974111975503
  },
  {
    "x": 27.243,
    "y": 251.9201,
    "angle": -2.001237898634713,
    "lengthA": 4.74031173410188,
    "lengthB": 4.740311734101882
  },
  {
    "x": 66.78,
    "y": 243.8781,
    "angle": 2.305906443042658,
    "lengthA": 6.084355887059487,
    "lengthB": 6.084355887059465
  },
  {
    "x": 70.9540042,
    "y": 196.948596,
    "angle": 1.0544462149553069,
    "lengthA": 12.507067510604696,
    "lengthB": 12.507068429602612
  },
  {
    "x": 49.087639,
    "y": 186.055749,
    "angle": 1.5707963267948966,
    "lengthA": 8.571568000000013,
    "lengthB": 27.972110999999984
  }
]